export default __webpack_public_path__ + "static/icon-exit-popups-0535e406eeb22b2895beb06ed273db7a.png";